<template>
  <section id="lnb">
    <div class="title">{{ firTitle }}</div>

    <ul
      class="depth01"
      v-for="(firDepth, firIndex) in firDepth"
      :key="firIndex"
    >
      <li
        :class="{ show: firDepth.selectMenu === true }"
        @click="dropdown(firDepth)"
      >
        <router-link class="tit" :to="firDepth.link" :title="firDepth.title">{{
          firDepth.title
        }}</router-link>
        <transition name="accordion">
          <ul class="depth02" v-if="firDepth.selectMenu === true">
            <li
              v-for="(secDepth, secIndex) in firDepth.menuList"
              :key="secIndex"
              :class="{
                on: secDepth.selectMenu === true,
                none: secDepth.link === '/customer',
              }"
              @click="menuSelect(secDepth)"
            >
              <router-link
                :to="secDepth.link"
                :class="{
                  link: secDepth.link === '/customer',
                }"
                :title="secDepth.title"
                >{{ secDepth.title }}</router-link
              >
            </li>
          </ul>
        </transition>
      </li>
    </ul>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';

export default {
  data() {
    return {
      firDepth: [],
      firTitle: '',
      firActive: {},
      secActive: {},
    };
  },

  created() {
    this.getTitle();
    this.getGnbMenuList();
    this.menuOpen();
  },

  watch: {
    firActive(nv, ov) {
      ov.selectMenu = false;
    },
    secActive(nv, ov) {
      ov.selectMenu = false;
      nv.selectMenu = true;
    },
    $route() {
      this.getTitle();
      this.getGnbMenuList();
      this.menuOpen();
    },
  },

  methods: {
    getTitle() {
      this.firTitle = '';
      this.firTitle = this.$route.meta.category[0];
    },

    getGnbMenuList() {
      const copy = cloneDeep(this.menuList);

      this.firDepth = copy.filter(v => {
        if (v.menuList) {
          v.menuList = v.menuList.filter(i => i != '');
        }
        return v;
      });
    },

    menuOpen() {
      this.firDepth.map(item => {
        item.selectMenu =
          item.title === this.$route.meta.category[0] ? true : false;
        item.menuList.map(v => {
          v.selectMenu =
            v.title === this.$route.meta.category[1] ? true : false;
          if (v.title === '요금감면 관리') {
            v.selectMenu = true;
          }
        });
      });
    },

    dropdown(firDepth) {
      this.firActive = firDepth;
    },
    menuSelect(secDepth) {
      secDepth.selectMenu = true;
      this.secActive = secDepth;
    },
  },

  computed: {
    ...mapGetters({
      menuList: 'getMenuList',
    }),
  },
};
</script>
